import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@trillion/ui/components/ui/button";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { ArticleForm } from "@/components/articles/article-form";
import { adminApi } from "@/lib/admin-api";
import type { Article } from "@/types";

export function ArticleNewPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(data: Partial<Article>) {
    setIsLoading(true);
    try {
      await adminApi.articles.create(data);
      toast.success("Article created successfully");
      navigate("/articles");
    } catch (err) {
      toast.error("Failed to create article", {
        description: err instanceof Error ? err.message : undefined,
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="New Article"
        description="Create a new help article"
        actions={
          <Button variant="outline" onClick={() => navigate("/articles")}>
            <ArrowLeft className="mr-2 size-4" />
            Back to Articles
          </Button>
        }
      />
      <ArticleForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}
